import type { OrganizationData } from '../contexts/organization-context';
import { useOrganization } from '../contexts/organization-context';

type RequiredOrganizationResult =
  | { organization: null; isLoading: true }
  | { organization: OrganizationData; isLoading: false };

/**
 * Wraps useOrganization with a discriminated union return type.
 * When `isLoading` is false, `organization` is guaranteed non-null.
 *
 * ```tsx
 * const { organization, isLoading } = useRequiredOrganization();
 * if (isLoading) return <LoadingState />;
 * // organization is OrganizationData (non-null) from here
 * ```
 */
export function useRequiredOrganization(): RequiredOrganizationResult {
  const { organization } = useOrganization();

  if (!organization) {
    return { organization: null, isLoading: true };
  }

  return { organization, isLoading: false };
}
